export default __webpack_public_path__ + "static/media/footer-mapa.373bee14.svg";